import authenticationGuard from './authentication.guard';
import initializingGuard from './initializing.guard';
import isAdminGuard from './admin.guard';

// The order matters!
export default [
    initializingGuard,
    authenticationGuard,
    isAdminGuard
];